 <template>
   <v-container class="login-container bg-dot-img">
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
        <LoginImageComponent />
      </v-col>
      <v-col
          cols="12"
          md="6"
        >
        <RideSideLoginComponenet />
      </v-col>
    </v-row>
  </v-container>
 </template>
 <script>
  import LoginImageComponent from './common/LoginImageComponent.vue';
  import RideSideLoginComponenet from './Login/RideSideLoginComponenet.vue';
   export default {
  //name: 'App',
  components: {
       LoginImageComponent,
       RideSideLoginComponenet,
      },
  data: () => ({
    //
  }),
  /*computed: {
       isPublic() {
           return this.$route.meta.isPublic ? true : false;
       }
   },*/
  methods: {
  }
};
 </script>